import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowToastMessage = createSelector(
  [(store: RootState) => store.profileDetail.showToastMessage],
  (usersList) => usersList
);
